export const messagesKey = 'messages';
export const threadsKey = 'threads-employer';
export const threadsEnterpriseKey = 'threads-enterprise';
export const messagesEnterpriseKey = 'messages-enterprise';
export const AITooltipText = 'Be clear, specific, and detailed about what you want—whether it’s a job description, a message, or your hiring culture. The more context and instructions you provide, the better the AI can understand and deliver exactly what you need.';
export const errorMessage = 'Sorry, there was an error getting messages';
